interface EndPoint {
  url?: string
  list?: string
  add?: string
  edit?: string
  delete?: string
  service?: string
}

export const end_points: Record<string, EndPoint> = {
  login: { url: '/Authentication/login', service: 'ms1' },
  getUsers: { url: '/User/get_all_users', service: 'ms1' },
  getTrucks: { url: '/truck/get_truck_details', service: 'ms1' },
  getTruckInspection: {
    url: '/checklist/get_transaction_summary',
    service: 'ms1',
  },
  getCheckListMaster: { url: '/checklist/get_checklist', service: 'ms1' },
  getCheckListTransactions: {
    url: '/checklist/checklist_transactions',
    service: 'ms1',
  },

  twofa: { url: '/auth/verify-2fa', service: 'ms1' },
  userInvitation: { url: '/invite/verify-user', service: 'ms1' },
  userInvitationRegister: { url: '/invite/user-register', service: 'ms1' },
  tileTypeList: { url: 'title-type-list', service: 'ms1' },
  personal_account: {
    url: '/user/profile-update',
    service: 'ms1',
  },
  user_two_factor: {
    url: '/user/update-2fa',
    service: 'ms1',
  },
  personal_change_password: {
    url: '/user/change-password',
    service: 'ms1',
  },
  customertypeaddedit: { url: '/settings/customertype/create', service: 'ms1' },
  customertypedelete: {
    url: '/settings/customertype/customertype/',
    service: 'ms1',
  },
  layoutsAdd: { url: '/settings/layoutsetting/add', service: 'ms1' },
  layoutsGet: { url: '/settings/layoutsetting/retrive', service: 'ms1' },
  vesselTypeAdd: { url: '/settings/vesseltype/create', service: 'ms1' },
  vesselTypeGet: { url: '/settings/vesseltype/list', service: 'ms1' },
  vesselTypeDelete: { url: '/settings/vesseltype/delete', service: 'ms1' },

  customertypelist: { url: '/settings/customertype/list', service: 'ms1' },
  deliverytermsaddedit: {
    url: '/settings/deliveryterms/create',
    service: 'ms1',
  },
  deliverytermsdelete: {
    url: '/settings/deliveryterms/delete/',
    service: 'ms1',
  },
  deliverytermslist: { url: '/settings/deliveryterms/list', service: 'ms1' },
  mailsettingsaddedit: { url: '/settings/mailsettings/create', service: 'ms1' },
  mailsettingsdelete: { url: '/settings/mailsettings/delete/', service: 'ms1' },
  mailsettingslist: { url: '/settings/mailsettings/list', service: 'ms1' },
  get_personal_account: {
    url: '/user/user-details',
    service: 'ms1',
  },
  get_company_profile: {
    url: '/companies/companies-details',
    service: 'ms1',
  },
  submit_company_profile: {
    url: '/companies/profile-update',
    service: 'ms1',
  },
  change_password: {
    url: '/user/change-password',
    service: 'ms1',
  },
  paymenttermlist: { url: '/settings/paymentterms/list', service: 'ms1' },
  paymenttermcreate: { url: '/settings/paymentterms/create', service: 'ms1' },
  paymenttermdelete: { url: '/settings/paymentterms/delete', service: 'ms1' },
  vatlist: { url: '/settings/vatsettings/list', service: 'ms1' },
  vatcreate: { url: '/settings/vatsettings/create', service: 'ms1' },
  vatdelete: { url: '/settings/vatsettings/delete', service: 'ms1' },
  purchaseInvoiceSettingscreate: {
    url: '/settings/purchaseinvoicesettings/create',
    service: 'ms1',
  },
  purchaseInvoiceSettingsretrvive: {
    url: '/settings/purchaseinvoicesettings/retrive',
    service: 'ms1',
  },
  purchaseEstimateSettingscreate: {
    url: '/settings/purchaseestimatesettings/create',
    service: 'ms1',
  },
  purchaseEstimateSettingsretrive: {
    url: '/settings/purchaseestimatesettings/retrive',
    service: 'ms1',
  },
  titletypelist: { url: '/settings/titletype/list', service: 'ms1' },
  titletypecreate: { url: '/settings/titletype/create', service: 'ms1' },
  titletypedelete: { url: '/settings/titletype/delete', service: 'ms1' },
  role: { url: '/settings/role/list', service: 'ms1' },
  roleModel: { url: '/settings/role/modules', service: 'ms1' },
  roleCreate: {
    url: '/settings/role/create',
    service: 'ms1',
  },
  roleDelete: {
    url: '/settings/role/delete',
    service: 'ms1',
  },
  deliveryOptionCreate: {
    url: '/settings/deliveryoptions/create',
    service: 'ms1',
  },
  deliveryOptionList: {
    url: '/settings/deliveryoptions/list',
    service: 'ms1',
  },
  deliveryOptionDelete: {
    url: '/settings/deliveryoptions/delete',
    service: 'ms1',
  },
  app_layout_details: {
    url: '/application/layout-details',
    service: 'ms1',
  },
  purchaseOrderSettingscreate: {
    url: '/settings/purchaseordersettings/create',
    service: 'ms1',
  },
  purchaseOrderSettingsretrive: {
    url: '/settings/purchaseordersettings/retrive',
    service: 'ms1',
  },
  purchaseInvoicestatelist: {
    url: '/settings/purchaseinvoicestatesettings/list',
    service: 'ms1',
  },
  purchaseInvoicestatecreate: {
    url: '/settings/purchaseinvoicestatesettings/create',
    service: 'ms1',
  },
  purchaseInvoicestatedelete: {
    url: '/settings/purchaseinvoicestatesettings/delete',
    service: 'ms1',
  },
  salesInvoiceSettingscreate: {
    url: '/settings/salesinvoicesettings/create',
    service: 'ms1',
  },
  salesInvoiceSettingsretrvive: {
    url: '/settings/salesinvoicesettings/retrive',
    service: 'ms1',
  },
  salesEstimateSettingscreate: {
    url: '/settings/salesestimatesettings/create',
    service: 'ms1',
  },
  salesEstimateSettingsretrvive: {
    url: '/settings/salesestimatesettings/retrive',
    service: 'ms1',
  },
  salesOrderSettingscreate: {
    url: '/settings/salesordersettings/create',
    service: 'ms1',
  },
  salesOrderSettingsretrive: {
    url: '/settings/salesordersettings/retrive',
    service: 'ms1',
  },
  salesInvoicestatelist: {
    url: '/settings/salesinvoicestatesettings/list',
    service: 'ms1',
  },
  salesInvoicestatecreate: {
    url: '/settings/salesinvoicestatesettings/create',
    service: 'ms1',
  },
  salesInvoicestatedelete: {
    url: '/settings/salesinvoicestatesettings/delete',
    service: 'ms1',
  },
  salesInvoicesCompanyList: {
    url: '/sales-invoice/list-company',
    service: 'ms1',
  },
  salesInvoicesVesselsList: {
    url: '/sales-invoice/list-vessel',
    service: 'ms1',
  },
  comapaniesAdd: {
    url: '/companies/create',
    service: 'ms1',
  },
  comapaniesList: {
    url: '/companies/list',
    service: 'ms1',
  },
  comapaniesStatus: {
    url: '/companies/update-status',
    service: 'ms1',
  },
  companiesDelete: {
    url: '/companies/delete/',
    service: 'ms1',
  },
  comapaniescontactList: {
    url: '/companies/companycontact-list',
    service: 'ms1',
  },
  comapaniescontactAdd: {
    url: '/companies/addcontact',
    service: 'ms1',
  },
  comapaniescontactDelete: {
    url: '/companies/deletecontact/',
    service: 'ms1',
  },
  comapaniesaddressList: {
    url: '/companies/companyaddress-list',
    service: 'ms1',
  },
  comapaniesaddressAdd: {
    url: '/companies/addaddress',
    service: 'ms1',
  },
  comapaniesaddressDelete: {
    url: '/companies/deleteaddress/',
    service: 'ms1',
  },
  comapaniesBankInfoList: {
    url: '/companies/companybankinfo-list',
    service: 'ms1',
  },
  comapaniesBankInfoAdd: {
    url: '/companies/addbankinfo',
    service: 'ms1',
  },
  comapaniesBankInfoDelete: {
    url: '/companies/deletebankinfo/',
  },
  userCreate: {
    url: '/user/create',
    service: 'ms1',
  },
  userUpdate: {
    url: '/user/update',
    service: 'ms1',
  },
  userList: {
    url: '/user/list',
    service: 'ms1',
  },
  inviteuserList: {
    url: '/user/invite-user-list',
    service: 'ms1',
  },
  userDelete: {
    url: '/user/delete',
    service: 'ms1',
  },
  userStatus: {
    url: '/user/update-status',
    service: 'ms1',
  },
  partenrUserRoleadd: {
    url: '/users-role/create',
    service: 'ms1',
  },
  partenrUserRoleupdate: {
    url: '/users-role/update',
    service: 'ms1',
  },
  partenrUserRoleget: {
    url: 'users-role/list',
    service: 'ms1',
  },
  partenrUserRoleDel: {
    url: 'users-role/delete',
    service: 'ms1',
  },
  partenrUserdefaultmodules: {
    url: 'users-role/defaultmodules',
    service: 'ms1',
  },
  vesselsCreate: {
    url: '/vessel/create',
    service: 'ms1',
  },
  vesselsUpdate: {
    url: '/vessel/update',
    service: 'ms1',
  },
  vesselsList: {
    url: '/vessel/list',
    service: 'ms1',
  },
  vesselsDelete: {
    url: '/vessel/delete',
    service: 'ms1',
  },
  vesselEquipmentsList: {
    url: '/vessel-equipment/list',
    service: 'ms1',
  },
  vesselEquipmentsDelete: {
    url: '/vessel-equipment/delete',
    service: 'ms1',
  },
  vesselEquipmentsCreate: {
    url: '/vessel-equipment/create',
    service: 'ms1',
  },
  vesselEquipmentsUpdate: {
    url: '/vessel-equipment/update',
    service: 'ms1',
  },

  workPictureList: {
    url: '/vessel/work-picture/list',
    service: 'ms1',
  },
  workPictureAdd: {
    url: '/vessel/work-picture/create',
    service: 'ms1',
  },
  workPictureDelete: {
    url: '/vessel/work-picture/delete',
    service: 'ms1',
  },
  serviceDocumentAdd: {
    url: '/vessels/service-record-document/document-upload',
    service: 'ms1',
  },
  serviceDocumentList: {
    url: '/vessels/service-record-document/list',
    service: 'ms1',
  },
  serviceDocumentDelete: {
    url: '/vessels/service-record-document/delete',
    service: 'ms1',
  },
  serviceRecordsNo: {
    url: '/vessels/service-record/get-servicerecordid',
    service: 'ms1',
  },
  serviceRecordsList: {
    url: '/vessels/service-record/list',
    service: 'ms1',
  },
  serviceRecordsAdd: {
    url: '/vessels/service-record/create',
    service: 'ms1',
  },
  serviceRecordsUpdate: {
    url: '/vessels/service-record/update',
    service: 'ms1',
  },
  serviceRecordsDelete: {
    url: '/vessels/service-record/delete',
    service: 'ms1',
  },
  serviceRecordsStatus: {
    url: '/vessels/service-record/update-status',
    service: 'ms1',
  },
  serviceFormAdd: {
    url: '/vessel/service-form/create',
    service: 'ms1',
  },
  serviceFormList: {
    url: '/vessel/service-form/list',
    service: 'ms1',
  },
  serviceFormDelete: {
    url: '/vessel/document/delete',
    service: 'ms1',
  },
  vesselsDocumentAdd: {
    url: '/vessel/document/document-upload',
    service: 'ms1',
  },
  vesselsDocumentList: {
    url: '/vessel/document/list',
    service: 'ms1',
  },
  vesselsDocumentDelete: {
    url: '/vessel/document/delete',
    service: 'ms1',
  },
  userInviteCreate: {
    url: 'user/invite-user',
    service: 'ms1',
  },
  userInviteList: {
    url: 'user/invite-user-list',
    service: 'ms1',
  },
  userInviteUpdate: {
    url: 'user/invite-user-update',
    service: 'ms1',
  },
  userAdminInvite: {
    url: 'invite/user-register',
    service: 'ms1',
  },
  getSalesEstimateNo: {
    url: 'sales/sales-estimate/get-sales-estimate-id',
    service: 'ms1',
  },
  salesEstimateCreate: {
    url: 'sales/sales-estimate/create',
    service: 'ms1',
  },
  salesEstimateUpdate: {
    url: 'sales/sales-estimate/update',
    service: 'ms1',
  },
  salesEstimateList: {
    url: 'sales/sales-estimate/list',
    service: 'ms1',
  },
  salesEstimateDelete: {
    url: 'sales/sales-estimate/delete',
    service: 'ms1',
  },
  // purchase estimation
  getpurchaseEstimateNo: {
    url: 'purchase/purchase-estimate/get-purchase-estimate-id',
    service: 'ms1',
  },
  purchaseEstimateCreate: {
    url: 'purchase/purchase-estimate/create',
    service: 'ms1',
  },
  purchaseEstimateUpdate: {
    url: 'purchase/purchase-estimate/update',
    service: 'ms1',
  },
  purchaseEstimateList: {
    url: 'purchase/purchase-estimate/list',
    service: 'ms1',
  },
  purchaseEstimateDelete: {
    url: 'purchase/purchase-estimate/delete',
    service: 'ms1',
  },
  purchaseRecievedEstimates: {
    url: 'purchase/purchase-estimate/add-request-estimate',
    service: 'ms1',
  },
  purchaseEstimateSummaryList: {
    url: 'purchase/purchase-estimate/summary-list',
    service: 'ms1',
  },
  salesEstimateSignatureUpdate: {
    url: 'sales/sales-estimate/update-signature',
    service: 'ms1',
  },
  // purchase order
  purchaseOrderId: {
    url: 'purchase/order/get-purchaseorderid',
    service: 'ms1',
  },
  purchaseOrderCreate: {
    url: 'purchase/order/create',
    service: 'ms1',
  },
  purchaseOrderList: {
    url: 'purchase/order/list',
    service: 'ms1',
  },
  purchaseOrderUpdate: {
    url: 'purchase/order/update',
    service: 'ms1',
  },
  purchaseOrderDelete: {
    url: 'purchase/order/delete',
    service: 'ms1',
  },
  // ---purchase Invoice Create

  getPurchaseInvoiceNo: {
    url: 'purchase/order/get-purchaseorderid',
    service: 'ms1',
  },
  purchaseInvoiceCreate: {
    url: 'purchase/invoice/create',
    service: 'ms1',
  },
  purchaseInvoiceUpdate: {
    url: 'purchase/invoice/update',
    service: 'ms1',
  },
  purchaseInvoiceList: {
    url: 'purchase/invoice/list',
    service: 'ms1',
  },
  purchaseInvoiceDelete: {
    url: 'purchase/invoice/delete',
    service: 'ms1',
  },
  purchaseInvoicePaymentCreate: {
    url: 'purchase/invoice/payment/create',
    service: 'ms1',
  },
  purchaseInvoicePaymentList: {
    url: 'purchase/invoice/payment/list',
    service: 'ms1',
  },
  purchaseInvoiceReturnCreate: {
    url: 'purchase/invoice/return/create',
    service: 'ms1',
  },
  purchaseInvoiceReturnDelete: {
    url: 'purchase/invoice/return/delete',
    service: 'ms1',
  },
  purchaseInvoiceReturnGet: {
    url: 'purchase/invoice/return/get',
    service: 'ms1',
  },
  purchaseInvoiceHistoryList: {
    url: 'purchase/invoice-history/list',
    service: 'ms1',
  },
  purchaseEstimateRequestedCompanyList: {
    url: 'purchase/purchase-estimate/get-company-details',
    service: 'ms1',
  },
  purchaseEstimateUpdateSelectedItems: {
    url: 'purchase/purchase-estimate/update-selected-items',
    service: 'ms1',
  },
  // ---purchase Invoice

  // ---sales order
  getSalesOrderNo: {
    url: 'sales-order/get-salesorderid',
    service: 'ms1',
  },
  salesOrderCreate: {
    url: 'sales-order/create',
    service: 'ms1',
  },
  salesOrderUpdate: {
    url: 'sales-order/update',
    service: 'ms1',
  },
  salesOrderList: {
    url: 'sales-order/list',
    service: 'ms1',
  },
  salesOrderDelete: {
    url: 'sales-order/delete',
    service: 'ms1',
  },
  getSalesInvoiceNo: {
    url: 'sales-invoice/get-salesinvoiceid',
    service: 'ms1',
  },
  salesInvoiceCreate: {
    url: 'sales-invoice/create',
    service: 'ms1',
  },
  salesInvoiceUpdate: {
    url: 'sales-invoice/update',
    service: 'ms1',
  },
  salesInvoiceList: {
    url: 'sales-invoice/list',
    service: 'ms1',
  },
  salesInvoiceDelete: {
    url: 'sales-invoice/delete',
    service: 'ms1',
  },
  salesInvoiceHistory: {
    url: 'sales-history/list',
    service: 'ms1',
  },
  salesInvoiceReturn: {
    url: 'return-sales-invoice/create',
    service: 'ms1',
  },
  userActivity: {
    url: 'users-activities/list',
    service: 'ms1',
  },
  salesInvoicePaymentCreate: {
    url: 'sales-invoice/payment-details/create',
    service: 'ms1',
  },
  salesInvoicePaymentReceipt: {
    url: 'sales-invoice/payment-details/list',
    service: 'ms1',
  },
  // sales order options
  salesOrderTemplateOptions: {
    url: 'settings/salesinvoicesettings/template-list',
    service: 'ms1',
  },
  salesOrderTemplateOptionDelete: {
    url: 'settings/salesinvoicesettings/template-delete',
    service: 'ms1',
  },
  salInvTemplateAdd: {
    url: 'settings/salesinvoicesettings/template-create',
    service: 'ms1',
  },
  salInvTemplateUpdate: {
    url: 'settings/salesinvoicesettings/template-update',
    service: 'ms1',
  },
  forgotPassword: {
    url: 'authentication/forgot_password',
    service: 'ms1',
  },
  resetPassword: {
    url: 'auth/reset-password',
    service: 'ms1',
  },
}
